module.exports = __webpack_public_path__ + "img/Slice2.e5bdac45.png";